(function (angular, $, window) {
    'use strict';

    window.THF.Angular.LiveQuoteTool.animation('.services', [function() {
        return {
            addClass: function(element, className, doneFn) {
                if( className == 'ng-hide' ) {
                    $(element).slideUp(function(){
                        doneFn();
                    });
                }
            },
            removeClass: function(element, className, doneFn) {
                if( className == 'ng-hide' ) {
                    $(element).slideDown(function(){
                        doneFn();
                    });
                }
            }
        }
    }]);


})(angular, jQuery, window);
